import React from "react";
import { Link } from "react-router-dom";

const ServiceAreaFive = () => {
  return (
    <>
      {/*=================== service area five start ===================*/}
      <div className="service-area bg-gray bg-relative pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="section-title text-center pd-top-100">
                <h6 className="sub-title-sky-blue">More Than Capital.</h6>
                <h2 className="title">Strategic Execution That Scales.</h2>
              </div>
            </div>
          </div>
          <div className="row custom-no-gutter">
            <div className="col-lg-4 col-md-6">
              <div className="single-service-inner-3 single-service-inner-3-left">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/7.svg" alt="Funding Jumpstart service icon" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">
                    <Link to="/funding/jumpstart">Funding Jumpstart</Link>
                  </h5>
                  <h6 className="mb-2">Get Clear Before You Raise</h6>
                  <p className="mb-2" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
                    For founders at idea or early traction stage
                  </p>
                  <p className="mb-2">
                    Most startups don't need money first — they need clarity.
                  </p>
                  <p className="mb-3">
                    <strong>Outcome:</strong><br />
                    ✔ Clear funding path<br />
                    ✔ Reduced risk<br />
                    ✔ Confidence in what to do next
                  </p>
                  <Link to="/funding/jumpstart" className="btn btn-sm" style={{ backgroundColor: '#50af9b', color: '#fff', padding: '8px 16px', borderRadius: '5px', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)', display: 'inline-block', textAlign: 'center' }}>
                    Explore Jumpstart →
                  </Link>
                </div>
              </div>
              <div className="single-service-inner-3 single-service-inner-3-left">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/8.svg" alt="Funding Boost service icon" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">
                    <Link to="/funding/boost">Funding Boost</Link>
                  </h5>
                  <h6 className="mb-2">Become Investor-Ready</h6>
                  <p className="mb-2" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
                    For startups preparing to raise grants or equity
                  </p>
                  <p className="mb-2">
                    Funding Boost turns promising startups into fundable businesses.
                  </p>
                  <p className="mb-3">
                    <strong>Outcome:</strong><br />
                    ✔ Investor-ready positioning<br />
                    ✔ Stronger pitches<br />
                    ✔ Smarter fundraising timing
                  </p>
                  <Link to="/funding/boost" className="btn btn-sm" style={{ backgroundColor: '#50af9b', color: '#fff', padding: '8px 16px', borderRadius: '5px', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)', display: 'inline-block', textAlign: 'center' }}>
                    Explore Boost →
                  </Link>
                </div>
              </div>
              <div className="single-service-inner-3 single-service-inner-3-left mb-0">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/9.svg" alt="Funding Advisory service icon" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">
                    <Link to="/funding/advisory">Funding Advisory</Link>
                  </h5>
                  <h6 className="mb-2">Strategic Capital, Done Right</h6>
                  <p className="mb-2" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
                    For growth-stage companies and serious founders
                  </p>
                  <p className="mb-2">
                    Hands-on, fractional-level support for companies where capital decisions matter.
                  </p>
                  <p className="mb-3">
                    <strong>Outcome:</strong><br />
                    ✔ Capital alignment<br />
                    ✔ Better terms<br />
                    ✔ Fewer costly mistakes
                  </p>
                  <Link to="/funding/advisory" className="btn btn-sm" style={{ backgroundColor: '#50af9b', color: '#fff', padding: '8px 16px', borderRadius: '5px', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)', display: 'inline-block', textAlign: 'center' }}>
                    Talk to Advisor →
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 bg-blue-right d-lg-inline-block d-none">
              <div className="service-thumb service-middle-section align-self-end">
                <video
                  autoPlay
                  muted
                  loop
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                >
                  <source src="/assets/video/evolvelab.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service-inner-3 single-service-inner-3-right">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/10.svg" alt="Accelerator Program service icon" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">
                    <Link to="/about">Accelerator Program</Link>
                  </h5>
                  <h6 className="mb-2">Build Faster. Learn Smarter. Move With Momentum.</h6>
                  <p className="mb-2" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
                    For founders ready to accelerate execution
                  </p>
                  <p className="mb-2">
                    The Evolvelab Accelerator is not theory — it's guided momentum.
                  </p>
                  <p className="mb-3">
                    <strong>Outcome:</strong><br />
                    ✔ Faster progress<br />
                    ✔ Reduced uncertainty<br />
                    ✔ Stronger execution discipline
                  </p>
                  <Link to="/about" className="btn btn-sm" style={{ backgroundColor: '#50af9b', color: '#fff', padding: '8px 16px', borderRadius: '5px', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)', display: 'inline-block', textAlign: 'center' }}>
                    View Program →
                  </Link>
                </div>
              </div>
              <div className="single-service-inner-3 single-service-inner-3-right">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/11.svg" alt="Dev Sprint service icon" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">
                    <Link to="/accelerator/dev-sprint">Dev Sprint</Link>
                  </h5>
                  <h6 className="mb-2">Turn Strategy Into Action</h6>
                  <p className="mb-2" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
                    For startups that need to move now
                  </p>
                  <p className="mb-2">
                    Translate strategy into real execution with clear build plans.
                  </p>
                  <p className="mb-3">
                    <strong>Outcome:</strong><br />
                    ✔ Clear build plan<br />
                    ✔ Focused execution<br />
                    ✔ Faster delivery
                  </p>
                  <Link to="/accelerator/dev-sprint" className="btn btn-sm" style={{ backgroundColor: '#50af9b', color: '#fff', padding: '8px 16px', borderRadius: '5px', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)', display: 'inline-block', textAlign: 'center' }}>
                    Start Sprint →
                  </Link>
                </div>
              </div>
              <div className="single-service-inner-3 single-service-inner-3-right mb-0">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/12.svg" alt="Dev Build & Scale service icon" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">
                    <Link to="/accelerator/dev-build">Dev Build & Scale</Link>
                  </h5>
                  <h6 className="mb-2">Build With Purpose. Scale With Confidence.</h6>
                  <p className="mb-2" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
                    For startups entering build or scale phase
                  </p>
                  <p className="mb-2">
                    Product development aligned with investor expectations and built for scale.
                  </p>
                  <p className="mb-3">
                    <strong>Outcome:</strong><br />
                    ✔ Investor-aligned product<br />
                    ✔ Reduced rebuild risk<br />
                    ✔ Scalable foundation
                  </p>
                  <Link to="/accelerator/dev-build" className="btn btn-sm" style={{ backgroundColor: '#50af9b', color: '#fff', padding: '8px 16px', borderRadius: '5px', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)', display: 'inline-block', textAlign: 'center' }}>
                    Explore Build →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =================== service area end ===================*/}
    </>
  );
};

export default ServiceAreaFive;
